import { render, staticRenderFns } from "./NielsenTable.vue?vue&type=template&id=da0e334e&"
import script from "./NielsenTable.vue?vue&type=script&lang=js&"
export * from "./NielsenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
